import ViewController from "./class.ViewController";
import TransporterLog from "./class.TransporterLog.js";

const LOGGER = new TransporterLog({
	attributes: {
		name: "TransporterErrors",
		color: "red",
	},
});

const caption = "Report a bug with this lesson.";

export default class TransporterErrors extends ViewController {
	constructor(options) {
		super(options);

		this.transporter = "";
		this.screenshot = "";

		this.ajaxRunner = new AoPS.Ajax.ScriptRunner("/s/transporter/ajax.php", {
			filter_interval: 0,
		});

		// build the error icon
		this.$errorIcon = $(
			`<div class="menu-icon error-icon"><span class="aops-font">˜</span></div>`
		)
			.attr("title", caption)
			.appendTo(this.$el)
			.click(() => {
				this.toggleErrorModal();
			});

		if (
			window.AoPS &&
			AoPS.Ecole &&
			AoPS.Ecole.Utils &&
			AoPS.Ecole.Utils.CreateTooltip
		) {
			AoPS.Ecole.Utils.CreateTooltip(this.$errorIcon, caption);
		}

		this.buildErrorMenu();
	}

	/**
	 * Toggles the error modal.
	 */
	toggleErrorModal() {
		var self = this;

		if (!this.$el.hasClass("dimmed") && window.html2canvas) {
			// Get what the screen looks like. Note that LaTeX images
			// probably won't be included in this screenshot due to CORS restrictions.
			var main_content = document.getElementById("main-content");
			window.html2canvas(main_content).then(function (canvas) {
				var canvasData = canvas.toDataURL("image/png");
				self.screenshot = canvasData.replace(
					/^data:image\/(png|jpg);base64,/,
					""
				);
			});

			// Get entire contents of the transporter doc, but not its wrapper.
			var layout = document.querySelector(".layout-container");
			window.html2canvas(layout).then(function (tCanvas) {
				var tData = tCanvas.toDataURL("image/png");
				self.transporter = tData.replace(/^data:image\/(png|jpg);base64,/, "");
			});
		}

		// If doesn't have dimmed class, then not currently open.
		this.$errorMenu.fadeToggle(200);
		this.$el.toggleClass("dimmed");
		this.mainView.$el.find(".menu-icon").fadeToggle(200);
		this.$errorMenu.find("textarea").focus();
	}

	buildErrorMenu() {
		this.$el.click((event) => {
			if ($(event.target).is(this.$el)) {
				this.toggleErrorModal();
			}
		});

		// build the error menu
		this.$errorMenu = $(`<div class="error-menu"></div>`)
			.appendTo(this.$el)
			.hide();

		// Report error title.
		this.$errorMenu.append(
			$(`<div class="error-title"><span>Report an Error</span></div>`)
		);

		// Close button
		this.$errorMenu.append(
			$(`<span class="close aops-font">J</span>`).click(() => {
				this.toggleErrorModal();
			})
		);

		// Build the error form.
		const $errorForm = $(`<div class="error-form"></div>`).appendTo(
			this.$errorMenu
		);

		$errorForm.append(
			$(`<p></p>`).text(
				`Please describe the error below. The actions you took during this lesson will be logged.`
			)
		);

		// Build the textarea
		const $textarea = $(`<textarea maxlength=2000></textarea>`);
		$errorForm.append(
			$textarea.on("input selectionchange propertychange", () => {
				this.$errorMenu
					.find(".error-form-buttons button:first")
					.prop("disabled", $textarea.val().length === 0);
			})
		);

		const $buttonDiv = $(`<div class="error-form-buttons"></div>`).appendTo(
			$errorForm
		);

		// Build the Submit button
		$buttonDiv.append(
			$(`<button class="btn btn-primary" disabled>Submit</button>`).click(
				() => {
					const text = $textarea.val();
					if (text.length > 0) {
						let class_id = 0;
						try {
							class_id = AoPS.bootstrap_data.grid_data.class.class_id;
						} catch (e) {
							LOGGER.error("Failed to get class_id for error report.", e);
						}

						// Hide modal
						this.toggleErrorModal();

						const report = {
							text: $textarea.val(),
							browser: navigator.appVersion || "",
							class_id,
							document_id: this.mainController.document_id,
							version: this.mainController.version,
							progress: JSON.stringify(
								this.mainController.inputController.save()
							),
							screenshot: this.screenshot,
							transporter: this.transporter,
						};

						this.sendReport(report);

						setTimeout(() => {
							$textarea.val("");
							this.$errorMenu
								.find(".error-form-buttons button:first")
								.prop("disabled", true);
						}, 200);
					}
				}
			)
		);

		// Build the Close button
		$buttonDiv.append(
			$(`<button class="btn btn-primary">Cancel</button>`).click(() => {
				this.toggleErrorModal();
			})
		);
	}

	/**
	 * Sends an error report.
	 * @param {{
	 * 		text: string,
	 * 		browser: string,
	 * 		class_id: number,
	 * 		document_id: number,
	 * 		version: number,
	 * 		progress: string,
	 * 	}} report
	 */
	sendReport(report) {
		this.ajaxRunner.run("report_bug", report, (success, result) => {
			if (success) {
				LOGGER.log("Error report successfully sent.");
			} else {
				LOGGER.error("Error report failed.", result);
			}
		});
	}
}
